import React, {useEffect} from "react";
import { Link } from "react-router-dom";

// destructuring props cause it showed some error
const CartButton = ({cartItems, setCartItems}) => {

  useEffect(()=>{
    setCartItems(localStorage.length)

    const handleChange = ()=>{
      setCartItems(localStorage.length)
    }

    // storage event fires when localStorage is modified
    window.addEventListener("storage", handleChange);

    return () => {
      //removes event listener when component unmounts
      window.removeEventListener("storage", handleChange);
    };

  },[setCartItems]);

  return (
    <div>
      <Link to="/cart" className="btn btn-warning fw-bold">
        Cart ({cartItems}) &nbsp;
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          className="bi bi-cart-check-fill"
          viewBox="0 0 16 16"
        >
          <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708" />
        </svg>
      </Link>
    </div>
  );
};

export default CartButton;
